import BossModel from "@/models/BossModel";
import Proposal from '@/models/Proposal/Proposal'
import Package from '@/models/Package/Package'
import Group from '@/models/Proposal/Group/Group'

export default class GroupPackage extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'proposal/group/package';

    /**
     *
     * @type {string}
     */
    static entity = 'groupPackages';

    static fields() {
		return {
			id: this.number(null).nullable(),
			proposal_group_id: this.number(null).nullable(),
			package_id: this.number(null).nullable(),
			title: this.attr(null),
			description: this.attr(null),
			package_type_id: this.number(null).nullable(),
			minimum_nights: this.attr(null),
			maximum_nights: this.attr(null),
			code: this.attr(null),
            group: this.belongsTo(Group, 'proposal_group_id'),
            package: this.belongsTo(Package, 'package_id'),
		}
	}

    /**
     *
     * @param gpackage
     * @returns {Promise<AxiosResponse<T>>}
     */
    static save(gpackage) {
        return this.api().create(gpackage);
    }

    /**
     *
     * @param proposalId
     */
    static loadByProposal(proposalId) {
        Proposal.api().with(['groups.package.package']).find(proposalId);
    }

    /**
     *
     * @returns {string}
     */
    FullCode() {
        switch (this.package_type_id) {
            case 1 : {
                return 'R - ' + this.code.pad(4);
            }
            case 2: {
                return 'A - ' + this.code.pad(4);
            }
            case 3: {
                return 'K - ' + this.code.pad(4);
            }
        }
    }

    /**
     *
     * @returns {boolean|*}
     */
    Group() {
        return this.getRelated('group');
    }

    /**
     *
     * @returns {boolean|*}
     */
    Package() {
        return this.getRelated('package');
    }
}
